import React, { Component } from "react";
import HeaderMenu from '../Components/HeaderMenu'
import Footerhow from '../Components/Footer-For-How/Footerhow'
import Discussionbody from './Howbody'


const Discussion = () => {
  return (
    <div className="">
      <HeaderMenu />
      <Discussionbody />
      <Footerhow />
    </div>
  );
}

export default Discussion;
